export default __webpack_public_path__ + "static/media/saurabh@4x.40596cfe.png";